const Mn = require('backbone.marionette');
const Template = require('jiji/ui/template/account/google.hbs');

module.exports = Mn.View.extend({
    tagName: 'li',
    className: 'collection-item avatar',
    template: Template
});



// WEBPACK FOOTER //
// ./jiji/ui/view/account/google.js